/* eslint-disable */
import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import ScenarioChartContent from './ScenarioChartContent';
import { useScenarioChartContext } from './ScenarioChartContext';

const ScenarioChartContainer = ({ hasNoTitle, height, isCollapsible, isInflationAdjustable, isMultiChart }) => {
  const {
    broadcastTimeframe,
    chartDataChartId,
    chartDataResource,
    chartDataTimeframe,
    initializingError,                                                  
    isInitializing,
    isChartRefreshing,
    query,
    setChartDataChartId,
    setChartDataTimeframe,
    setChartDataUsePresentData,
    usePresentData,
  } = useScenarioChartContext();

  return (
    <DataContainer
      component={ScenarioChartContent}
      componentProps={{
        broadcastTimeframe,
        chartDataChartId,
        chartDataResource,
        chartDataTimeframe,
        hasNoTitle,
        height,
        isCollapsible,
        isInflationAdjustable,
        isMultiChart,
        query,
        setChartDataChartId,
        setChartDataTimeframe,
        setChartDataUsePresentData,
        usePresentData,
        isChartRefreshing,
      }}
      loading={isInitializing}
      loadingError={initializingError}
    />
  );
};

export default ScenarioChartContainer;
